import React from 'react';

export type SsoData = {
  isFetchingIdps: boolean;
  identityProviders: Array<{ ssoIdentityProviderUid: string; displayName: string }>;
  ssoError?: string;
  ssoIdentityProviderUid?: string;
};

export const DEFAULT_SSO_DATA: SsoData = {
  isFetchingIdps: false,
  identityProviders: [],
};

type SsoDataContextValue = {
  ssoData: SsoData;
  setSsoData: React.Dispatch<React.SetStateAction<SsoData>>;
};

export const SsoDataContext = React.createContext<SsoDataContextValue>({
  ssoData: DEFAULT_SSO_DATA,
  setSsoData: () => null,
});
